//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('pohCompAddScan', {
//        templateUrl: 'views/components/views/pohCompAddScan/pohCompAddScan.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'pohCompAddScanService', function ($stateParams, stateService, utilityService, modalService, pohCompAddScanService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let pohKeyno = $stateParams.poh_keyno;

//            vm.model = {
//                barcodeButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('barcode') },
//                    { id: 'calculator', icon: 'fa fa-calculator', color: 'primary', type: 'primary', onClick: () => openCalculator('barcode') },
//                    { id: 'search', icon: 'fas fa-search', color: 'success', type: 'success', onClick: () => handleScan() }
//                ],
//                setting: {
//                    barcode: ''
//                }
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region HANDLE SCAN FUNCTION

//            function handleScan() {
//                if (utilityService.validateParmsValue(vm.model.setting.barcode) !== true) return;

//                pohCompAddScanService.scanBarcode({
//                    poh_keyno: pohKeyno,
//                    barcode: vm.model.setting.barcode
//                }).then((response) => {
//                    stateService.go(response[0].webpagename, {
//                        poh_keyno: pohKeyno,
//                        stock_keyno: response[0].stock_keyno
//                    });
//                });

//                clear('barcode');
//            }

//            // #endregion HANDLE SCAN FUNCTION

//            // #region OPEN CALCULATOR DIALOGUE BOX FUNCTION

//            function openCalculator(id) {
//                switch (id) {
//                    case 'barcode':
//                        modalService.showCalculator(vm.model.setting[id]).then(function (value) {
//                            vm.model.setting[id] = value;
//                            handleScan();
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion OPEN CALCULATOR DIALOGUE BOX FUNCTION

//            // #region MULTI CLEAR FUNCTION

//            function clear(id) {
//                switch (id) {
//                    case 'barcode':
//                        if (vm.model.setting.barcode > '') {
//                            vm.model.setting.barcode = '';
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion MULTI CLEAR FUNCTION

//            // #region SUBMIT SEARCH FUNCTION

//            vm.submitSearch = async function () {
//                handleScan();
//            }

//            // #endregion SUBMIT SEARCH FUNCTION
            
//        }]
//    });
//})();
